<template>
  <div>
    <onboarding-bar v-if="isNeedOnboarding" :onboarding-data="onboardingInfo"/>
    <onboarding-pending-bar v-if="isUnderReview" :onboarding-data="onboardingInfo"/>
    <HeaderDesktop v-if="isDesktop" />
    <HeaderMobile
      v-else
      :is-main-menu-open="isMainMenuOpen"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderDesktop from './header-desktop';
import HeaderMobile from './header-mobile';
import { OnboardingBar, OnboardingPendingBar } from '@/features/onboarding-block';

export default {
  props: {
    isMainMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: { HeaderDesktop, HeaderMobile, OnboardingBar, OnboardingPendingBar },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
    ...mapGetters('currentUserModule', ['isMainPartner', 'isNeedOnboarding', 'onboardingInfo', 'isUnderReview',]),
  }
};
</script>
